import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Privacy = () => {
  return (
    <>
      <Header />
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="space-y-8">
          <div className="text-sm text-gray-600">
            Effective Date: January 10, 2025
          </div>

          <section className="space-y-6">
            <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
            
            <div className="space-y-6">
              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Introduction</h2>
                <p className="text-gray-700 leading-relaxed">
                  At ArcAdvantage.ai, we are committed to respecting your privacy and ensuring transparency in how we handle your personal information. This Privacy Policy outlines the types of information we collect, how we use it, and the measures we take to safeguard it when you visit our website (arcadvantage.ai) or interact with us online.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Information We Collect</h2>
                <p className="text-gray-700 mb-4">We may collect the following types of information to enhance your experience and provide our services:</p>
                <div className="space-y-4 pl-6">
                  <div>
                    <h3 className="font-medium text-gray-900">Information You Provide:</h3>
                    <p className="text-gray-700">This includes your name, email address, and any other details you voluntarily share with us when completing forms, subscribing, or contacting us.</p>
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-900">Automatic Information:</h3>
                    <p className="text-gray-700">Technical details such as your IP address, browser type, operating system, and pages viewed to help us analyze and improve website performance.</p>
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-900">Cookies:</h3>
                    <p className="text-gray-700">We use cookies to improve functionality and enhance user experience. You can control cookie settings through your browser preferences.</p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">3. How We Use Your Information</h2>
                <p className="text-gray-700 mb-2">We utilize the information collected to:</p>
                <ul className="list-disc pl-6 space-y-2 text-gray-700">
                  <li>Ensure the website functions effectively and meets your needs.</li>
                  <li>Respond to your inquiries and provide requested support or services.</li>
                  <li>Send you updates, newsletters, or other communications, provided you have opted in to receive them.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Data Security</h2>
                <p className="text-gray-700">
                  We employ industry-standard security measures to protect your information from unauthorized access, alteration, or disclosure. While we strive to ensure data protection, please note that no system is entirely foolproof.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Your Rights and Choices</h2>
                <p className="text-gray-700 mb-4">You have the following options regarding your information:</p>
                <div className="space-y-4 pl-6">
                  <div>
                    <h3 className="font-medium text-gray-900">Access and Update:</h3>
                    <p className="text-gray-700">Contact us to review or update the information we have about you.</p>
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-900">Opt-Out:</h3>
                    <p className="text-gray-700">Unsubscribe from our communications by clicking the link in any email you receive from us.</p>
                  </div>
                  <div>
                    <h3 className="font-medium text-gray-900">Cookie Preferences:</h3>
                    <p className="text-gray-700">Adjust your browser settings to manage or disable cookies.</p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Third-Party Links</h2>
                <p className="text-gray-700">
                  Our website may contain links to external websites. Please be aware that we are not responsible for the privacy practices of these third-party sites. We recommend reviewing their privacy policies for further information.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Updates to This Privacy Policy</h2>
                <p className="text-gray-700">
                  We may revise this Privacy Policy periodically. Any changes will be posted on this page with the updated "Effective Date." We encourage you to review the policy regularly to stay informed about how we are protecting your information.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Contact Us</h2>
                <p className="text-gray-700">
                  If you have any questions or concerns about this Privacy Policy or how your information is handled, please reach out to us:
                </p>
                <div className="mt-4 space-y-1 text-gray-700">
                  <p>ArcAdvantage.ai</p>
                  <p>111 West Lewis Street,<br/>Suite 118,<br/>Greensboro, NC 27406<br/>USA</p>
                  <p>Email: support@arcadvantage.ai</p>
                  
                </div>
              </section>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Privacy;